export default item => ({
  slug: item.excursionId,
  name: item.name,
  prices: item.prices,
})
